import React, { Fragment, useState, useEffect } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { rejectInPrinciple } from '../../common/constants/api';
import CommonSelect from '../../components/Dashboard-res/CommonComponent/CommonSelect';
import get from 'lodash/get';
import _ from 'lodash';
import {
  FailureSvg,
  SuccessDes
} from '../../common/components/PopUp/CommonSvgs';

const validationSchema = Yup.object().shape({
  reason: Yup.object().shape({
    value: Yup.string().required('Required')
  }),
  comments: Yup.string().when('reason.value', {
    is: 'OTHER',
    then: Yup.string().required('Required')
  })
});

let rejectReasons = [
  {
    label: 'Documents are missing',
    value: 'DOCUMENTS_MISSING'
  },
  {
    label: 'Documents are incorrect',
    value: 'DOCUMENTS_INCORRECT'
  },
  {
    label: 'Documents Data are a mismatch',
    value: 'DOCUMENT_DATA_MISMATCH'
  },
  {
    label: 'Documents are unreadable',
    value: 'DOCUMENTS_UNREADABLE'
  },
  {
    label: 'Other',
    value: 'OTHER'
  }
];
const RejectModal = ({ leadId, setIsRejected }) => {
  const [rejectSuccess, setRejectSuccess] = useState(false);
  const [rejectFailure, setRejectFailure] = useState(false);
  const [errMsg, setErrMsg] = useState('');
  return (
    <Fragment>
      <Formik
        initialValues={{
          reason: {
            label: 'Select a reason',
            value: ''
          },
          comments: ''
        }}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          setSubmitting(true);
        }}
      >
        {propsFromFormik => {
          const {
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            setFieldValue,
            handleSubmit,
            setFieldTouched,
            setFieldError,
            validateForm,
            isSubmitting
          } = propsFromFormik;

          useEffect(() => {
            validateForm();
          }, []);

          const onSubmitHandler = () => {
            setRejectSuccess(false);
            setRejectFailure(false);
            setErrMsg('');

            let body = {
              reason: values.reason.value,
              comment: values.comments
            };
            rejectInPrinciple(leadId, body)
              .then(res => {
                setIsRejected(true);
                setRejectSuccess(true);
              })
              .catch(err => {
                setIsRejected(false);
                setErrMsg(
                  err?.response?.data?.message ||
                    'Something went wrong please try again letter'
                );
                setRejectFailure(true);
              });
          };
          if (rejectSuccess) {
            return (
              <div className="flex flex-col justfy-center items-center content-center text-center">
                <SuccessDes />
                <div className="text-black-1003 mx-auto">
                  Application has been rejected successfully
                </div>
              </div>
            );
          }

          if (rejectFailure) {
            return (
              <div className="flex flex-col  items-center content-center text-center">
                <FailureSvg />
                {errMsg && <div className="text-red-100">{errMsg}</div>}
              </div>
            );
          } else {
            return (
              <div className="flex flex-col py-5">
                <div>
                  <p className="font-roboto font-medium text-base text-black-1003 ">
                    Please choose a reason to reject
                  </p>
                  <CommonSelect sort={true}
                    name="reason"
                    value={values.reason}
                    onChange={anyvalue => {
                      setFieldValue('reason', anyvalue, true);
                      setFieldTouched('reason', true, false);
                    }}
                    onBlur={() => {
                      setFieldTouched('reason', true, true);
                    }}
                    options={[
                      {
                        label: 'select a reason below',
                        value: ''
                      },
                      ...rejectReasons
                    ]}
                    stylesContainer={{
                      height: '52px',
                      marginBottom: '40px',
                      fontSize: '40px'
                    }}
                    dropdownStyle={{
                      top: '55px'
                    }}
                    styleText={{
                      fontSize: '14px',
                      padding: '0 25px'
                    }}
                    error={touched.reason && get(errors, 'reason.value', false)}
                    errorMsg={get(errors, 'reason.value', false)}
                    touched={touched.reason}
                  />
                </div>
                <div>
                  <p className="font-roboto font-medium text-base text-black-1003 ">
                    Add comment (optional)
                  </p>
                  <textarea
                    name="comments"
                    id="comments"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.comments}
                    style={{
                      height: '150px',
                      minWidth: '100%',
                      border: '1px solid #cacaca',
                      padding: '10px'
                    }}
                  />
                  {errors.comments && (
                    <div className="text-red-100">{errors.comments}</div>
                  )}
                </div>
                <button
                  onClick={onSubmitHandler}
                  disabled={!_.isEmpty(errors)}
                  className="submitButton w-40 lg:w-56 font-semibold "
                  type="button"
                  id="submit"
                >
                  reject
                </button>
              </div>
            );
          }
        }}
      </Formik>
    </Fragment>
  );
};
export default RejectModal;
